// Generic Empty Action Type
export const NO_ACTION                                      = 'NO_ACTION';

// App
export const APP_BOOTSTRAP                                  = 'APP_BOOTSTRAP';
export const APP_INIT                                       =  'APP_INIT';
export const APP_POST_LOGIN_PROCESS                         = 'APP_POST_LOGIN_PROCESS';
export const APP_UTM_SET                                    = 'APP_UTM_SET';

// Authentication
export const AUTH_USER_SET                                  = 'AUTH_USER_SET';
export const AUTH_COMPANY_SET                               = 'AUTH_COMPANY_SET';
export const AUTH_DELETE                                    = 'AUTH_DELETE';

// Billing
export const BILLING_CREATE                                 = 'BILLING_CREATE';
export const BILLING_VIEW                                   = 'BILLING_VIEW';
export const BILLING_FETCH                                  = 'BILLING_FETCH';
export const BILLING_FETCH_ABORT                            = 'BILLING_FETCH_ABORT';
export const BILLING_FETCH_ERROR                            = 'BILLING_FETCH_ERROR';
export const BILLING_UPDATE                                 = 'BILLING_UPDATE';
export const BILLING_SET                                    = 'BILLING_SET';
export const BILLING_KEY_FETCH                              = 'BILLING_KEY_FETCH';
export const BILLING_KEY_SET                                = 'BILLING_KEY_SET';
export const BILLING_ESTIMATE_FETCH                         = 'BILLING_ESTIMATE_FETCH';
export const BILLING_ESTIMATE_FETCH_ABORT                   = 'BILLING_ESTIMATE_FETCH_ABORT';
export const BILLING_ESTIMATE_FETCH_ERROR                   = 'BILLING_ESTIMATE_FETCH_ERROR';
export const BILLING_ESTIMATE_SET                           = 'BILLING_ESTIMATE_SET';
export const BILLING_INVOICE_FETCH                          = 'BILLING_INVOICE_FETCH';
export const BILLING_INVOICE_FETCH_ABORT                    = 'BILLING_INVOICE_FETCH_ABORT';
export const BILLING_INVOICE_FETCH_ERROR                    = 'BILLING_INVOICE_FETCH_ERROR';
export const BILLING_INVOICES_FETCH                         = 'BILLING_INVOICES_FETCH';
export const BILLING_INVOICES_FETCH_ABORT                   = 'BILLING_INVOICES_FETCH_ABORT';
export const BILLING_INVOICES_FETCH_ERROR                   = 'BILLING_INVOICES_FETCH_ERROR';
export const BILLING_PLAN_CHANGE_START                      = 'BILLING_PLAN_CHANGE_START';
export const BILLING_USERS_FETCH                            = 'BILLING_USERS_FETCH';
export const BILLING_USERS_FETCH_MORE                       = 'BILLING_USERS_FETCH_MORE';
export const BILLING_USAGE_REPORT_FETCH                     = 'BILLING_USAGE_REPORT_FETCH';
export const BILLING_USAGE_REPORT_FETCH_ERROR               = 'BILLING_USAGE_REPORT_FETCH_ERROR';
export const BILLING_USAGE_REPORT_FETCH_ABORT               = 'BILLING_USAGE_REPORT_FETCH_ABORT';
export const BILLING_USAGE_REPORT_SET                       = 'BILLING_USAGE_REPORT_SET';
export const BILLING_SUBSCRIPTION_CANCEL                    = 'BILLING_SUBSCRIPTION_CANCEL';
export const BILLING_SUBSCRIBE                              = 'BILLING_SUBSCRIBE';
export const BILLING_SUBSCRIBE_ERROR                        = 'BILLING_SUBSCRIBE_ERROR';
export const BILLING_SUBSCRIBE_ABORT                        = 'BILLING_SUBSCRIBE_ABORT';
export const BILLING_SUBSCRIBE_START                        = 'BILLING_SUBSCRIBE_START';
export const BILLING_PAYMENT_START                          = 'BILLING_PAYMENT_START';
export const BILLING_DETAILS_START                          = 'BILLING_DETAILS_START';
export const BILLING_UPGRADE_REQUEST                        = 'BILLING_UPGRADE_REQUEST';
export const BILLING_TRIAL_START                            = 'BILLING_TRIAL_START';
export const BILLING_LOCATION_SUBSCRIPTION_UPDATE           = 'BILLING_LOCATION_SUBSCRIPTION_UPDATE';

// Company
export const COMPANY_FETCH                                  = 'COMPANY_FETCH';
export const COMPANY_FETCH_ABORT                            = 'COMPANY_FETCH_ABORT';
export const COMPANY_FETCH_ERROR                            = 'COMPANY_FETCH_ERROR';
export const COMPANY_UPDATE                                 = 'COMPANY_UPDATE';
export const COMPANY_DELETE                                 = 'COMPANY_DELETE';
export const COMPANY_SET                                    = 'COMPANY_SET';
export const COMPANY_FEATURES_SET                           = 'COMPANY_FEATURES_SET';
export const COMPANY_FEATURES_FETCH                         = 'COMPANY_FEATURES_FETCH';
export const COMPANY_LOCATION_IDS_SET                       = 'COMPANY_LOCATION_IDS_SET';
export const COMPANY_LOCATIONS_FETCH                        = 'COMPANY_LOCATIONS_FETCH';
export const COMPANY_SCHEDULES_FETCH                        = 'COMPANY_SCHEDULES_FETCH';

// Country
export const COUNTRY_FETCH                                  = 'COUNTRY_FETCH';
export const COUNTRY_SET                                    = 'COUNTRY_SET';

// Currency
export const CURRENCY_LOCALE_REFRESH                        = 'CURRENCY_LOCALE_REFRESH';

// Datetime formats
export const DATETIME_FORMAT_FETCH                          = 'DATETIME_FORMAT_FETCH';
export const DATETIME_FORMAT_SET                            = 'DATETIME_FORMAT_SET';

// Contractors
export const CONTRACTOR_CREATE                               = 'CONTRACTOR_CREATE';
export const CONTRACTOR_UPDATE                               = 'CONTRACTOR_UPDATE';
export const CONTRACTOR_PATCH                                = 'CONTRACTOR_PATCH';
export const CONTRACTOR_FETCH                                = 'CONTRACTOR_FETCH';
export const CONTRACTOR_VIEWED_SET                           = 'CONTRACTOR_VIEWED_SET';
export const CONTRACTOR_EXCLUDE                              = 'CONTRACTOR_EXCLUDE';
export const CONTRACTOR_INVITE                               = 'CONTRACTOR_INVITE';
export const CONTRACTOR_RESTART                              = 'CONTRACTOR_RESTART';
export const CONTRACTOR_TERMINATE                            = 'CONTRACTOR_TERMINATE';

export const CONTRACTORS_FETCH                               = 'CONTRACTORS_FETCH';
export const CONTRACTORS_FETCH_ABORT                         = 'CONTRACTORS_FETCH_ABORT';
export const CONTRACTORS_FETCH_ERROR                         = 'CONTRACTORS_FETCH_ERROR';
export const CONTRACTORS_SET                                 = 'CONTRACTORS_SET';

export const CONTRACTOR_DOCUMENT_DOWNLOAD                    = 'CONTRACTOR_DOCUMENT_DOWNLOAD';
export const CONTRACTOR_DOCUMENTS_FETCH                      = 'CONTRACTOR_DOCUMENTS_FETCH';
export const CONTRACTOR_DOCUMENTS_FETCH_MORE                 = 'CONTRACTOR_DOCUMENTS_FETCH_MORE';
export const CONTRACTOR_DOCUMENTS_RELATION_SET               = 'CONTRACTOR_DOCUMENTS_RELATION_SET';
export const CONTRACTOR_DOCUMENTS_MORE_RELATION_SET          = 'CONTRACTOR_DOCUMENTS_MORE_RELATION_SET';

export const CONTRACTOR_PAYMENT_DOWNLOAD                     = 'CONTRACTOR_PAYMENT_DOWNLOAD';
export const CONTRACTOR_PAYMENTS_FETCH                       = 'CONTRACTOR_PAYMENTS_FETCH';
export const CONTRACTOR_PAYMENTS_FETCH_MORE                  = 'CONTRACTOR_PAYMENTS_FETCH_MORE';
export const CONTRACTOR_PAYMENTS_RELATION_SET                = 'CONTRACTOR_PAYMENTS_RELATION_SET';
export const CONTRACTOR_PAYMENTS_MORE_RELATION_SET           = 'CONTRACTOR_PAYMENTS_MORE_RELATION_SET';

// Employees
export const EMPLOYEE_CREATE                                = 'EMPLOYEE_CREATE';
export const EMPLOYEE_UPDATE                                = 'EMPLOYEE_UPDATE';
export const EMPLOYEE_PATCH                                 = 'EMPLOYEE_PATCH';
export const EMPLOYEE_EXCLUDE                               = 'EMPLOYEE_EXCLUDE';
export const EMPLOYEE_FETCH                                 = 'EMPLOYEE_FETCH';
export const EMPLOYEE_INVITE                                = 'EMPLOYEE_INVITE';
export const EMPLOYEE_RESTART                               = 'EMPLOYEE_RESTART';
export const EMPLOYEE_TERMINATE                             = 'EMPLOYEE_TERMINATE';
export const EMPLOYEE_WAGE_UPDATE                           = 'EMPLOYEE_WAGE_UPDATE';
export const EMPLOYEE_WAGE_DELETE_PENDING                   = 'EMPLOYEE_WAGE_DELETE_PENDING';

export const EMPLOYEE_BENEFITS_FETCH                        = 'EMPLOYEE_BENEFITS_FETCH';
export const EMPLOYEE_BENEFITS_FETCH_MORE                   = 'EMPLOYEE_BENEFITS_FETCH_MORE';
export const EMPLOYEE_BENEFITS_RELATION_SET                 = 'EMPLOYEE_BENEFITS_RELATION_SET';
export const EMPLOYEE_BENEFITS_MORE_RELATION_SET            = 'EMPLOYEE_BENEFITS_MORE_RELATION_SET';
export const EMPLOYEE_BENEFITS_MANAGEMENT_LAUNCH            = 'EMPLOYEE_BENEFITS_MANAGEMENT_LAUNCH';

export const EMPLOYEE_DOCUMENT_DOWNLOAD                     = 'EMPLOYEE_DOCUMENT_DOWNLOAD';
export const EMPLOYEE_DOCUMENTS_FETCH                       = 'EMPLOYEE_DOCUMENTS_FETCH';
export const EMPLOYEE_DOCUMENTS_FETCH_MORE                  = 'EMPLOYEE_DOCUMENTS_FETCH_MORE';
export const EMPLOYEE_DOCUMENTS_RELATION_SET                = 'EMPLOYEE_DOCUMENTS_RELATION_SET';
export const EMPLOYEE_DOCUMENTS_MORE_RELATION_SET           = 'EMPLOYEE_DOCUMENTS_MORE_RELATION_SET';

export const EMPLOYEE_DEDUCTIONS_FETCH                      = 'EMPLOYEE_DEDUCTIONS_FETCH';
export const EMPLOYEE_DEDUCTIONS_FETCH_MORE                 = 'EMPLOYEE_DEDUCTIONS_FETCH_MORE';
export const EMPLOYEE_DEDUCTIONS_RELATION_SET               = 'EMPLOYEE_DEDUCTIONS_RELATION_SET';
export const EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET          = 'EMPLOYEE_DEDUCTIONS_MORE_RELATION_SET';
export const EMPLOYEE_DEDUCTIONS_MANAGEMENT_LAUNCH          = 'EMPLOYEE_DEDUCTIONS_MANAGEMENT_LAUNCH';

export const EMPLOYEE_LEAVE_BALANCE_UPDATE                 = 'EMPLOYEE_LEAVE_BALANCE_UPDATE';

export const EMPLOYEE_WAGES_FETCH                          = 'EMPLOYEE_WAGES_FETCH';
export const EMPLOYEE_WAGES_RELATION_SET                   = 'EMPLOYEE_WAGES_RELATION_SET';

export const EMPLOYEE_PAYSTUB_DOWNLOAD                      = 'EMPLOYEE_PAYSTUB_DOWNLOAD';
export const EMPLOYEE_PAYSTUBS_FETCH                        = 'EMPLOYEE_PAYSTUBS_FETCH';
export const EMPLOYEE_PAYSTUBS_FETCH_MORE                   = 'EMPLOYEE_PAYSTUBS_FETCH_MORE';
export const EMPLOYEE_PAYSTUBS_RELATION_SET                 = 'EMPLOYEE_PAYSTUBS_RELATION_SET';
export const EMPLOYEE_PAYSTUBS_MORE_RELATION_SET            = 'EMPLOYEE_PAYSTUBS_MORE_RELATION_SET';
export const EMPLOYEE_VIEWED_SET                            = 'EMPLOYEE_VIEWED_SET';

export const EMPLOYEES_FETCH                                = 'EMPLOYEES_FETCH';
export const EMPLOYEES_PATCH                                = 'EMPLOYEES_PATCH';
export const EMPLOYEES_FETCH_ABORT                          = 'EMPLOYEES_FETCH_ABORT';
export const EMPLOYEES_FETCH_ERROR                          = 'EMPLOYEES_FETCH_ERROR';
export const EMPLOYEES_SET                                  = 'EMPLOYEES_SET';
export const EMPLOYEES_SUGGESTIONS_FETCH                    = 'EMPLOYEES_SUGGESTIONS_FETCH';
export const EMPLOYEES_SUGGESTIONS_FETCH_ABORT              = 'EMPLOYEES_SUGGESTIONS_FETCH_ABORT';
export const EMPLOYEES_SUGGESTIONS_FETCH_ERROR              = 'EMPLOYEES_SUGGESTIONS_FETCH_ERROR';
export const EMPLOYEES_SUGGESTIONS_SET                      = 'EMPLOYEES_SUGGESTIONS_SET';
export const EMPLOYEES_LEAVE_BALANCE_REPORT_DOWNLOAD        = 'EMPLOYEES_LEAVE_BALANCE_REPORT_DOWNLOAD';

// Global
export const GLOBAL_FETCH                                   = 'GLOBAL_FETCH';
export const GLOBAL_SET                                     = 'GLOBAL_SET';
export const GLOBAL_INDUSTRIES_SET                          = 'GLOBAL_INDUSTRIES_SET';
export const GLOBAL_SETTINGS_FETCH                          = 'GLOBAL_SETTINGS_FETCH';
export const GLOBAL_SETTINGS_SET                            = 'GLOBAL_SETTINGS_SET';
export const GLOBAL_TIMEZONES_SET                           = 'GLOBAL_TIMEZONES_SET';
export const GLOBAL_DATETIME_FORMAT_SET                     = 'GLOBAL_DATETIME_FORMAT_SET';

// Industries
export const INDUSTRIES_FETCH                               = 'INDUSTRIES_FETCH';
export const INDUSTRIES_FETCH_ABORT                         = 'INDUSTRIES_FETCH_ABORT';
export const INDUSTRIES_FETCH_ERROR                         = 'INDUSTRIES_FETCH_ERROR';
export const INDUSTRIES_SET                                 = 'INDUSTRIES_SET';

// Intercom
export const INTERCOM_BOOT                                  = 'INTERCOM_BOOT';
export const INTERCOM_SHUTDOWN                              = 'INTERCOM_SHUTDOWN';

// List
export const LIST_DESELECT                                  = 'LIST_DESELECT';
export const LIST_DESELECT_BY_GROUP                         = 'LIST_DESELECT_BY_GROUP';
export const LIST_ITEM_SET                                  = 'LIST_ITEM_SET';
export const LIST_ITEM_UNSET                                = 'LIST_ITEM_UNSET';
export const LIST_ITEM_REMOVE                               = 'LIST_ITEM_REMOVE';
export const LIST_ITEMS_UNSET_ALL                           = 'LIST_ITEMS_UNSET_ALL';
export const LIST_MERGE                                     = 'LIST_MERGE';
export const LIST_SET                                       = 'LIST_SET';
export const LIST_SELECT                                    = 'LIST_SELECT';
export const LIST_SELECT_BY_GROUP                           = 'LIST_SELECT_BY_GROUP';
export const LIST_HIGHLIGHT                                 = 'LIST_HIGHLIGHT';
export const LIST_UNHIGHLIGHT                               = 'LIST_UNHIGHLIGHT';
export const LIST_FETCHING_SET                              = 'LIST_FETCHING_SET';
export const LIST_FETCHING_MORE_SET                         = 'LIST_FETCHING_MORE_SET';
export const LIST_ARRANGE_BY                                = 'LIST_ARRANGE_BY';
export const LIST_SORT_BY                                   = 'LIST_SORT_BY';
export const LIST_SORT_UNSET                                = 'LIST_SORT_UNSET';
export const LIST_SELECTION_MODE_SET                        = 'LIST_SELECTION_MODE_SET';
export const LIST_BULK_UPDATING_SET                         = 'LIST_BULK_UPDATING_SET';
export const LIST_COLUMN_IDS_SET                            = 'LIST_COLUMN_IDS_SET';

export const FILTER_SET                                     = 'FILTER_SET';
export const FILTER_UNSET                                   = 'FILTER_UNSET';

// App Reload
export const FORCE_RELOAD                                   = 'FORCE_RELOAD';

// Location
export const LOCATION_ADD_START                             = 'LOCATION_ADD_START';
export const LOCATION_FETCH                                 = 'LOCATION_FETCH';
export const LOCATION_SET                                   = 'LOCATION_SET';
export const LOCATION_ENTITY_SET                            = 'LOCATION_ENTITY_SET';
export const LOCATION_CREATE                                = 'LOCATION_CREATE';
export const LOCATION_UPDATE                                = 'LOCATION_UPDATE';
export const LOCATION_DELETE                                = 'LOCATION_DELETE';
export const LOCATION_DELETE_START                          = 'LOCATION_DELETE_START';
export const LOCATION_REMOVE                                = 'LOCATION_REMOVE';
export const LOCATION_SCHEDULES_FETCH                       = 'LOCATION_SCHEDULES_FETCH';
export const LOCATION_SCHEDULES_FETCH_ABORT                 = 'LOCATION_SCHEDULES_FETCH_ABORT';
export const LOCATION_VIEWED_SET                            = 'LOCATION_VIEWED_SET';
export const LOCATION_SCHEDULES_SET                         = 'LOCATION_SCHEDULES_SET';
export const LOCATION_COMPANY_SCHEDULES_RELATION_SET        = 'LOCATION_COMPANY_SCHEDULES_RELATION_SET';
export const LOCATION_COMPANY_SCHEDULES_RELATION_REMOVE     = 'LOCATION_COMPANY_SCHEDULES_RELATION_REMOVE';
export const LOCATION_USER_SCHEDULES_RELATION_SET           = 'LOCATION_USER_SCHEDULES_RELATION_SET';
export const LOCATION_USER_SCHEDULES_RELATION_REMOVE        = 'LOCATION_USER_SCHEDULES_RELATION_REMOVE';

export const LOCATIONS_FETCH                                = 'LOCATIONS_FETCH';
export const LOCATIONS_SET                                  = 'LOCATIONS_SET';

export const LOCATION_RULES_SET                             = 'LOCATION_RULES_SET';
export const LOCATION_RULES_VIEW                            = 'LOCATION_RULES_VIEW';
export const LOCATION_RULES_UPDATE                          = 'LOCATION_RULES_UPDATE';
export const LOCATION_RULES_UPDATE_ABORT                    = 'LOCATION_RULES_UPDATE_ABORT';
export const LOCATION_RULES_FETCH                           = 'LOCATION_RULES_FETCH';
export const LOCATION_RULES_FETCH_ABORT                     = 'LOCATION_RULES_FETCH_ABORT';
export const LOCATION_RULES_FETCH_MORE                      = 'LOCATION_RULES_FETCH_MORE';
export const LOCATION_RULES_FETCH_MORE_ABORT                = 'LOCATION_RULES_FETCH_MORE_ABORT';

// Login
export const LOGIN                                          = 'LOGIN';
export const LOGIN_COMPANY                                  = 'LOGIN_COMPANY';
export const LOGIN_USER                                     = 'LOGIN_USER';
export const LOGIN_SSO                                      = 'LOGIN_SSO';
export const LOGIN_SUCCESSFUL                               = 'LOGIN_SUCCESSFUL';
export const LOGIN_ERROR                                    = 'LOGIN_ERROR';
export const LOGOUT                                         = 'LOGOUT';
export const LOGOUT_POST                                    = 'LOGOUT_POST';

// GO - SSO
export const GO_INIT = 'GO_INIT';
export const GO_POST_PROCESS_LOGIN = 'GO_POST_PROCESS_LOGIN';

// Onboarding
export const ONBOARDING_FETCH_URL                            = 'ONBOARDING_FETCH_URL';

// Password Management
export const PASSWORD_REQUEST_VERIFICATION_CODE             = 'PASSWORD_REQUEST_VERIFICATION_CODE';
export const PASSWORD_SUBMIT_VERIFICATION_CODE              = 'PASSWORD_SUBMIT_VERIFICATION_CODE';
export const PASSWORD_RESET                                 = 'PASSWORD_RESET';

// Payroll
export const PAYROLLS_FETCH                                 = 'PAYROLLS_FETCH';
export const PAYROLLS_FETCH_MORE                            = 'PAYROLLS_FETCH_MORE';
export const PAYROLL_CREATE                                 = 'PAYROLL_CREATE';
export const PAYROLL_DELETE                                 = 'PAYROLL_DELETE';
export const PAYROLL_REOPEN                                 = 'PAYROLL_REOPEN';
export const PAYROLL_IMPORT                                 = 'PAYROLL_IMPORT';
export const PAYROLLS_SET                                   = 'PAYROLLS_SET';
export const PAYROLL_HISTORY_FETCH                          = 'PAYROLL_HISTORY_FETCH';
export const PAYROLL_HISTORY_FETCH_MORE                     = 'PAYROLL_HISTORY_FETCH_MORE';
export const PAYROLL_HISTORY_SET                            = 'PAYROLL_HISTORY_SET';
export const PAYROLL_HISTORY_EXPORT_JOURNAL                 = 'PAYROLL_HISTORY_EXPORT_JOURNAL';
export const PAYROLL_HISTORY_SUMMARY_DOWNLOAD               = 'PAYROLL_HISTORY_SUMMARY_DOWNLOAD';
export const PAYROLL_PAYSTUBS_DOWNLOAD                      = 'PAYROLL_PAYSTUBS_DOWNLOAD';
export const PAYROLL_CASH_REQUIREMENT_DOWNLOAD              = 'PAYROLL_CASH_REQUIREMENT_DOWNLOAD';
export const PAYROLL_FETCH                                  = 'PAYROLL_FETCH';
export const PAYROLL_VIEWED_SET                             = 'PAYROLL_VIEWED_SET';
export const PAYROLL_DETAILS_LAUNCH                         = 'PAYROLL_DETAILS_LAUNCH';

// Preferences

export const PREFERENCE_SET                                 = 'PREFERENCE_SET';
export const PREFERENCE_MERGE                               = 'PREFERENCE_MERGE';
export const PREFERENCE_COMPANY_SET                         = 'PREFERENCE_COMPANY_SET';
export const PREFERENCE_CONNECTIONS_SET                     = 'PREFERENCE_CONNECTIONS_SET';
export const PREFERENCE_LOCATION_SET                        = 'PREFERENCE_LOCATION_SET';
export const PREFERENCE_MULTI_LOCATION_SET                  = 'PREFERENCE_MULTI_LOCATION_SET';
export const PREFERENCE_START_BAR_SET                       = 'PREFERENCE_START_BAR_SET';
export const PREFERENCE_COMPLIANCE_RULES_SET                = 'PREFERENCE_COMPLIANCE_RULES_SET';
export const PREFERENCE_COMPLIANCE_RULES_UNSET              = 'PREFERENCE_COMPLIANCE_RULES_UNSET';
export const PREFERENCE_EXPORT_REPORT_SET                   = 'PREFERENCE_EXPORT_REPORT_SET';
export const PREFERENCE_UNIT_MEASUREMENT_SET                = 'PREFERENCE_UNIT_MEASUREMENT_SET';
export const PREFERENCE_SAVE                                = 'PREFERENCE_SAVE';
export const PREFERENCE_FETCH                               = 'PREFERENCE_FETCH';
export const PREFERENCE_SORT_GROUP_SET                      = 'PREFERENCE_SORT_GROUP_SET';

// Reports
export const REPORTS_RUN_LAUNCH                             = 'REPORTS_RUN_LAUNCH';
export const REPORTS_RUN_PAYROLLSUMMARY                     = 'REPORTS_RUN_PAYROLLSUMMARY';
export const REPORTS_RUN_PAYROLLJOURNAL                     = 'REPORTS_RUN_PAYROLLJOURNAL';
export const REPORTS_RUN_TAXLIABILITIES                     = 'REPORTS_RUN_TAXLIABILITIES';
export const REPORTS_RUN_BENEFITS                           = 'REPORTS_RUN_BENEFITS';
export const REPORTS_RUN_CONTRACTORPAYMENTS                 = 'REPORTS_RUN_CONTRACTORPAYMENTS';
export const REPORTS_RUN_CHILDSUPPORTPAYMENTS               = 'REPORTS_RUN_CHILDSUPPORTPAYMENTS';
export const REPORTS_RUN_W4EXEMPTSTATUS                     = 'REPORTS_RUN_W4EXEMPTSTATUS';

// Generic Router Action Type;
export const ROUTER_GO                                      = 'ROUTER_GO';
export const ROUTER_GO_BACK                                 = 'ROUTER_GO_BACK';
export const ROUTER_NAVIGATION                              = 'ROUTER_NAVIGATION';
export const ROUTER_REDIRECT_TO_URL                         = 'ROUTER_REDIRECT_TO_URL';
export const ROUTER_TO_CHILD_NAVIGATION                     = 'ROUTER_TO_CHILD_NAVIGATION';
export const ROUTER_NAVIGATION_CANCEL                       = 'ROUTER_NAVIGATION_CANCEL';
export const ROUTER_NAVIGATION_SUCCESS                      = 'ROUTER_NAVIGATION_SUCCESS';
export const ROUTER_CANCEL                                  = 'ROUTER_CANCEL';
export const ROUTER_ERROR                                   = 'ROUTER_ERROR';
export const ROUTER_STATE_SET                               = 'ROUTER_STATE_SET';

// Session
export const SESSION_LOCALE_SET                             = 'SESSION_LOCALE_SET';
export const SESSION_USER_FETCH                             = 'SESSION_USER_FETCH';
export const SESSION_USER_SET                               = 'SESSION_USER_SET';
export const SESSION_USER_PERMISSIONS_FETCH                 = 'SESSION_USER_PERMISSIONS_FETCH';
export const SESSION_USER_PERMISSIONS_SET                   = 'SESSION_USER_PERMISSIONS_SET';
export const SESSION_COMPANY_FETCH                          = 'SESSION_COMPANY_FETCH';
export const SESSION_COMPANY_SET                            = 'SESSION_COMPANY_SET';
export const SESSION_COMPANY_FEATURES_FETCH                 = 'SESSION_COMPANY_FEATURES_FETCH';
export const SESSION_COMPANY_FEATURES_SET                   = 'SESSION_COMPANY_FEATURES_SET';
export const SESSION_COMPANY_STATUS_SET                     = 'SESSION_COMPANY_STATUS_SET';
export const SESSION_INIT                                   = 'SESSION_INIT';
export const SESSION_INIT_COMPLETE                          = 'SESSION_INIT_COMPLETE';
export const SESSION_REDIRECT_STATE_SET                     = 'SESSION_REDIRECT_STATE_SET';
export const SESSION_COUNTRY_FETCH                          = 'SESSION_COUNTRY_FETCH';
export const SESSION_COUNTRY_SET                            = 'SESSION_COUNTRY_SET';
export const SESSION_SKILLSETS_FETCH                        = 'SESSION_SKILLSETS_FETCH';
export const SESSION_SKILLSETS_SET                          = 'SESSION_SKILLSETS_SET';
export const SESSION_CLEAR                                  = 'SESSION_CLEAR';
export const SESSION_MOMENT_LOCALE_UPDATE                   = 'SESSION_MOMENT_LOCALE_UPDATE';

export const SETTINGS_FETCH                                 = 'SETTINGS_FETCH';
export const SETTINGS_SET                                   = 'SETTINGS_SET';
export const SETTINGS_TIPS_SET                              = 'SETTINGS_TIPS_SET';
export const SETTINGS_FETCHING_SET                          = 'SETTINGS_FETCHING_SET';
export const SETTINGS_UPDATE                                = 'SETTINGS_UPDATE';
export const SETTINGS_LEAVEPOLICIES_FETCH                   = 'SETTINGS_LEAVEPOLICIES_FETCH';
export const SETTINGS_LEAVEPOLICIES_FETCH_ABORT             = 'SETTINGS_LEAVEPOLICIES_FETCH_ABORT';
export const SETTINGS_LEAVEPOLICIES_FETCH_ERROR             = 'SETTINGS_LEAVEPOLICIES_FETCH_ERROR';
export const SETTINGS_LEAVEPOLICIES_SET                     = 'SETTINGS_LEAVEPOLICIES_SET';
export const SETTINGS_LEAVEPOLICY_FETCH                     = 'SETTINGS_LEAVEPOLICY_FETCH';
export const SETTINGS_LEAVEPOLICY_VIEWED_SET                = 'SETTINGS_LEAVEPOLICY_VIEWED_SET';
export const SETTINGS_LEAVEPOLICY_EMPLOYEES_UPDATE          = 'SETTINGS_LEAVEPOLICY_EMPLOYEES_UPDATE';
export const SETTINGS_LEAVEPOLICY_NEW_UPDATE                = 'SETTINGS_LEAVEPOLICY_NEW_UPDATE';
export const SETTINGS_LEAVEPOLICY_NEW_RESET                 = 'SETTINGS_LEAVEPOLICY_NEW_RESET';
export const SETTINGS_LEAVEPOLICY_CREATE                    = 'SETTINGS_LEAVEPOLICY_CREATE';
export const SETTINGS_TIMEOFF_TYPES_FETCH                   = 'SETTINGS_TIMEOFF_TYPES_FETCH';
export const SETTINGS_TIMEOFF_TYPES_SET                     = 'SETTINGS_TIMEOFF_TYPES_SET';
export const SETTINGS_TIMEOFF_TYPES_RESET                   = 'SETTINGS_TIMEOFF_TYPES_RESET';

// Taxation
export const TAXATION_DEPOSITS_FETCH                       = 'TAXATION_DEPOSITS_FETCH';
export const TAXATION_DEPOSITS_FETCH_MORE                  = 'TAXATION_DEPOSITS_FETCH_MORE';
export const TAXATION_DEPOSITS_FETCH_ABORT                 = 'TAXATION_DEPOSITS_FETCH_ABORT';
export const TAXATION_DEPOSITS_FETCH_ERROR                 = 'TAXATION_DEPOSITS_FETCH_ERROR';
export const TAXATION_DEPOSITS_SET                         = 'TAXATION_DEPOSITS_SET';
export const TAXATION_DEPOSIT_FETCH_URL                    = 'TAXATION_DEPOSIT_FETCH_URL';

export const TAXATION_DOCUMENTS_FETCH                       = 'TAXATION_DOCUMENTS_FETCH';
export const TAXATION_DOCUMENTS_FETCH_MORE                  = 'TAXATION_DOCUMENTS_FETCH_MORE';
export const TAXATION_DOCUMENTS_FETCH_ABORT                 = 'TAXATION_DOCUMENTS_FETCH_ABORT';
export const TAXATION_DOCUMENTS_FETCH_ERROR                 = 'TAXATION_DOCUMENTS_FETCH_ERROR';
export const TAXATION_DOCUMENTS_SET                         = 'TAXATION_DOCUMENTS_SET';
export const TAXATION_DOCUMENT_DOWNLOAD                     = 'TAXATION_DOCUMENT_DOWNLOAD';

// Timezones
export const TIMEZONES_FETCH                                = 'TIMEZONES_FETCH';
export const TIMEZONES_SET                                  = 'TIMEZONES_SET';

// Toast
export const TOAST_SET                                      = 'TOAST_SET';
export const TOAST_FLUSH                                    = 'TOAST_FLUSH';
export const TOAST_SHOW                                     = 'TOAST_SHOW';

// User (Logged in user)
export const USER_UPDATE                                    = 'USER_UPDATE';
export const USER_EMAIL_UPDATE                              = 'USER_EMAIL_UPDATE';
export const USER_PHONE_UPDATE                              = 'USER_PHONE_UPDATE';
export const USER_SET                                       = 'USER_SET';

// Users (Other users)
export const USERS_CREATE                                   = 'USERS_CREATE';
export const USERS_DELETE                                   = 'USERS_DELETE';
export const USERS_FETCH                                    = 'USERS_FETCH';
export const USERS_INVITATION_RESEND                        = 'USERS_INVITATION_RESEND';

// User datetime formats
export const USER_DATETIME_FORMAT_FETCH                     = 'USER_DATETIME_FORMAT_FETCH';
export const USER_DATETIME_FORMAT_SET                       = 'USER_DATETIME_FORMAT_SET';

// Workplaces
export const WORKPLACES_FETCH                                = 'WORKPLACES_FETCH';
export const WORKPLACES_SET                                  = 'WORKPLACES_SET';
export const WORKPLACES_FETCH_MORE                           = 'WORKPLACES_FETCH_MORE';

export const WORKPLACE_CREATE                                = 'WORKPLACE_CREATE';
export const WORKPLACE_DELETE                                = 'WORKPLACE_DELETE';
export const WORKPLACE_DELETE_START                          = 'WORKPLACE_DELETE_START';
export const WORKPLACE_ENTITY_SET                            = 'WORKPLACE_ENTITY_SET';
export const WORKPLACE_FETCH                                 = 'WORKPLACE_FETCH';
export const WORKPLACE_UPDATE                                = 'WORKPLACE_UPDATE';
export const WORKPLACE_VIEWED_SET                            = 'WORKPLACE_VIEWED_SET';
